import { render, staticRenderFns } from "./SelectInput.vue?vue&type=template&id=f08475c4&scoped=true&"
import script from "./SelectInput.vue?vue&type=script&lang=js&"
export * from "./SelectInput.vue?vue&type=script&lang=js&"
import style0 from "./SelectInput.vue?vue&type=style&index=0&id=f08475c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f08475c4",
  null
  
)

export default component.exports